import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import UserRestServices from '../../services/user-rest.service';
import Config from '../../utils/config.service';
import Toast from '../../services/toast.service';
import DialogServices from '../../services/dialog.service';
import BusinessRestServices from '../../services/business-rest.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import $ from 'jquery';
import moment from 'moment';
import { Input, Output, EventEmitter } from '@angular/core';
import { ModalCsvInstructionsComponent } from '../modal-csv-instructions/modal-csv-instructions.component';
import { MatSelectModule } from '@angular/material/select';

@Component({
	standalone: true,
	selector: 'item-invitation',
	templateUrl: './item-invitation.component.html',
	imports: [
		CommonModule, MatSelectModule, LowerCasePipe, TranslatePipe, 
		LoaderOverlayComponent, InputDatepickerNewComponent, 
		ItemErrorComponent, FormsModule
	]
})
export class ItemInvitationComponent implements OnInit {
	private userRestServices: UserRestServices = inject(UserRestServices);
	private config: Config = inject(Config);
	private toast: Toast = inject(Toast);
	private dialogServices: DialogServices = inject(DialogServices);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() form: any | undefined;
	@Output() formChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	@Input() employee: any | undefined;
	@Output() employeeChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.uid = Date.now();
		
		this.vm.user = this.session.getSession().user;
		this.vm.canUserManuallyAddInsurance = this.session.canUserManuallyAddInsurance();
		this.vm.isInsuranceDatePickerHidden = this.session.isInsuranceDatePickerHidden();
		if (this.vm.canUserManuallyAddInsurance) {
			this.vm.activePolicies = this.vm.user.activeInsurancePolicies;
		}
		
		this.initNewEmployee();
		
		if (this.vm.user.service.insuranceChangesInFuture) {
			var today: any = new Date();
			var minDate: any = new Date();
			minDate.setDate(today.getDate() + this.config.getOtherConfig().INSURANCE_CHANGE_DELAY_IN_DAYS);
			this.vm.minDate = minDate;
		} else {
			this.vm.minDate = new Date(2020, 0, 1);
		}
		this.vm.handleSubmit = this.handleSubmit;
		this.vm.openInstructionsModal = this.openInstructionsModal;
		this.vm.uploadCSV = this.uploadCSV;
		
		this.vm.isPersonalCodeRequiredForInvite = this.vm.user.origin == 'minudoc.ee'
			&& !this.vm.user.service.personalCodeNotRequiredForInvite;
	}
	
	handleSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.processing) return;
		var names: any = this.getNames();
		
		var data: any = {
			firstName: names.first,
			lastName: names.last,
			email: this.vm.employee.email,
			personalCode: this.vm.employee.idcode,
			additionalInfo: this.vm.employee.additionalInfo,
			additionalInfo2: this.vm.employee.additionalInfo2
		};
		if (this.vm.invitationExtra && this.vm.invitationExtra.policy && this.vm.invitationExtra.policy.policyNumber) {
			data.invitationExtras = [];
			var extraData: any = {};
			extraData.policy = {};
			extraData.policy.policyNumber = this.vm.invitationExtra.policy.policyNumber;
			extraData.activationDate = this.vm.invitationExtra.activationDate
				? moment(this.vm.invitationExtra.activationDate).utcOffset(0, true).toDate()
				: new Date();
			extraData.terminationDate = this.vm.invitationExtra.terminationDate
				? moment(this.vm.invitationExtra.terminationDate).utcOffset(0, true).toDate()
				: undefined;
			data.invitationExtras.push(extraData);
		}
		
		this.businessRestServices.inviteWorker(data,
			() => {
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Employees.ADDED);
				this.vm.submitted = false;
				this.vm.processing = false;
				this.initNewEmployee();
				mainForm.reset();
			},
			() => {
				this.vm.processing = false;
			}
		);
	}
	
	initNewEmployee() {
		this.vm.employee = {};
		if (this.vm.canUserManuallyAddInsurance) {
			this.vm.invitationExtra = {};
			this.vm.invitationExtra.policy = {};
		}
	}
	
	getNames() {
		var arr: any = this.vm.employee.name.split(' ');
		arr = arr.filter((el) => { return el.trim(); });
		var names: any = {};
		names.last = arr.pop();
		names.first = arr.join(' ');
		
		return names;
	}
	
	openInstructionsModal() {
		this.dialogServices.show({
			controller: ModalCsvInstructionsComponent
		});
	}
	
	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		this.uploadCSV(input.files);
	}
	
	uploadCSV(files) {
		if (!files || !files.length || this.vm.processing) return;
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig().LOADER_TIMEOUT_INIT);
		var file: any = files[0];
		var data: any = new FormData();
		data.append('file', file);
		this.userRestServices.uploadCSV({ name: file.name }, data,
			() => {
				this.handleUploadOnComplete(true);
				this.toast.showAsync(this.angularFilterHelperService.translate('Employees.Import_Successful'));
			},
			() => {
				this.handleUploadOnComplete();
				this.toast.showAsync(this.angularFilterHelperService.translate('Employees.Errors.Import'), null, null, 'error');
			}
		);
	}
	
	handleUploadOnComplete(isSuccessful?) {
		$('#file-' + this.vm.uid).val('');
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) {
			this.angularHelperService.createTimer(() => {
				this.vm.processing = false;
				if (isSuccessful) this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Employees.ADDED);
			}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		}
	}
	
}